import axios from 'axios'
import config from '../config'
import { getDoctorToken } from '../utils'

const resetForgotPasswordApi = async (params) => {
    const response = await axios({
        url: `${config.api.base_url}doctor/reset-forgot-password`,
        method: "patch",
        data: params,


        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${getDoctorToken()}`
        }
    })
    return response

}

export default resetForgotPasswordApi